<template>
	<div :class="[$style['data-item'], { [$style['data-item--nowrap']]: nowrap }]">
		<span v-if="label" :class="$style['data-item__caption']">
			{{ label }}
		</span>
		<slot>
			<span :class="$style['data-item__content']">{{ content }}</span>
		</slot>
	</div>
</template>

<script>
export default {
	name: 'DataItem',
	props: {
		label: {
			type: String,
			default: null
		},
		content: {
			type: String,
			default: null
		},
		nowrap: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style module lang="scss">
.data-item {
    display: flex;
    flex-direction: column;
    flex: 1;
    // min-width: min(100%, max-content);
    font-size: 16px;

    &--nowrap {
        white-space: nowrap;
    }

    &__inline {
        display: flex;
        justify-content: space-between;
        margin: 0 -5px;
        padding: 2px 5px;

        &--active {
            background-color: getColor(highlight);
            width: 90%;
        }

        &__icon {
            font-size: 14px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
        }
    }

    &__clickable {
        cursor: pointer;
    }

    &__caption {
        font-size: 12px;
        color: getColor(caption);
        margin-bottom: 5px;

        &--green {
            padding-left: $gutter;
            color: getColor(success);
        }

        &__icon {
            margin-top: $gutter;
        }
    }

    &__content {
        margin: calc($gutter / 2) 0;
    }

    &--flex-row {
        display: flex;
        flex-flow: row;
        align-items: center;
    }
}
</style>
